<template>
  <v-card flat>
    <v-dialog v-model="showImage" fullscreen>
      <v-img
        @click="showImage=false"
        :src="showImageUrl"
        max-height="100%"
      />
    </v-dialog>
    <v-card-actions class="d-print-none">
      <v-btn
        :loading="isLoading"
        @click="generateMenu">
        Generate Menu
      </v-btn>
      <v-spacer/>
      <v-btn
        outlined
        @click="showTextMenu=!showTextMenu">
        {{ showTextMenu ? 'Full Menu' : 'Text Menu' }}
      </v-btn>
      <v-spacer/>
      <v-checkbox
        v-model="hideChefChoice"
        label="Hide Chef Choice Meals"
        hide-details
        class="mt-0 pt-0"
      />
      <v-spacer/>
      <router-link :to="{name:'MenuEdit'}">Edit Chef Choice Menu</router-link>
      <v-spacer/>
      <router-link :to="{name:'IngredientStopWords'}">Hidden Ingredient Words</router-link>
      <v-spacer/>
      <v-menu
        ref="menu"
        v-model="dateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            label="Picker in menu"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
          :allowed-dates="isSunday"
        >
          <v-spacer></v-spacer>
          <!--          <v-btn-->
          <!--            text-->
          <!--            color="primary"-->
          <!--            @click="menu = false"-->
          <!--          >-->
          <!--            Cancel-->
          <!--          </v-btn>-->
          <!--          <v-btn-->
          <!--            text-->
          <!--            color="primary"-->
          <!--            @click="$refs.menu.save(date)"-->
          <!--          >-->
          <!--            OK-->
          <!--          </v-btn>-->
        </v-date-picker>
      </v-menu>

    </v-card-actions>
    <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="primary"
      class="d-print-none"
    />
    <v-card-text v-if="error">
      <v-alert type="warning">{{ error }}</v-alert>
    </v-card-text>
    <v-card-text>
      <v-row>
        <!--        <v-col cols="3">-->
        <!--          <v-date-picker-->
        <!--            v-model="date"-->
        <!--            :allowed-dates="isSunday"-->
        <!--          />-->
        <!--        </v-col>-->
        <v-col v-if="menu">
          <!--          <h1>Menu for week {{ date }}</h1>-->
          <v-btn-toggle v-if="!showTextMenu" v-model="filter" class="d-print-none">
            <v-btn
              v-for="stream of Object.keys(displayMenu)"
              v-bind:key="stream"
              :value="stream">{{ stream }}
            </v-btn>
          </v-btn-toggle>
          <!--          <pre>{{ Object.keys(menu.full) }}</pre>-->
          <v-card v-if="showTextMenu" flat>
            <div class="d-flex flex-wrap align-center d-print-none">
              <v-checkbox
                v-for="stream of Object.keys(displayMenu)"
                v-bind:key="stream"
                v-model="selectedTextStreams"
                :value="stream"
                :label="getStreamName(stream) || stream"
                hide-details
                class="mt-0 mr-4"
              />
              <v-spacer/>
              <v-btn outlined @click="copyTextMenu">
                <v-icon left>{{ textMenuCopied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
                Copy
              </v-btn>
            </div>
            <v-card-text>
              <!-- ref on a plain div: v-card-text is functional, so a ref on it is never set -->
              <div ref="textMenu">
              <div v-for="({menu},stream) of textMenu" v-bind:key="stream">
                <h2 class="mt-4">{{ getStreamName(stream) || stream }}</h2>
                <p v-if="streams[stream] && streams[stream].description">
                  {{ streams[stream].description }}
                </p>
                <div v-for="({date,meals,products},index) of menu" v-bind:key="index">
                  <h3 class="mt-2">{{ date === 'any' ? 'Chef Choice Meals' : textMenuDate(date) }}</h3>
                  <div v-for="meal of sortByTod(products||meals)" v-bind:key="meal.id">
                    {{ meal.tod }} - {{ meal.name }}
                  </div>
                </div>
              </div>
              </div>
            </v-card-text>
          </v-card>
          <template v-else>
          <v-card
            v-for="({menu,updated_at},stream) of activeMenu"
            v-bind:key="stream"
          >
            <v-card-title><h1>{{ getStreamName(stream) || stream }}<template v-if="getStreamName(stream)"> ({{ stream }})</template></h1></v-card-title>
            <v-card-text v-for="({date,meals,products},index) of menu" v-bind:key="index">
              <h2 v-if="date!=='any'">Meals on {{ dateFormatted(date) }}</h2>
              <h2 v-if="date==='any'">Chef Choice Meals</h2>
              <v-card class="my-4" v-for="(meal,mealIndex) of (products||meals)" v-bind:key="mealIndex">
                <v-card-title>
                  {{ date === 'any' ? '' : dateFormatted(date) }}
                  {{ meal.tod }}
                  <span v-if="meal.deliveryDate">(delivery {{ dateFormatted(meal.deliveryDate) }})</span>
                  <v-spacer/>
                  <v-chip outlined>{{ meal.stream }}</v-chip>
                  <br/>
                </v-card-title>
                <v-card-text>
                  <h3>
                    <template v-if="meal.price">{{ formatCurrency(meal.price) }}</template>
                    {{ meal.name }} (M{{ meal.id }})
                  </h3>
                  <p>{{ meal.ingredients }}</p>
                  <v-row>
                    <v-col
                      cols="3"
                      v-for="(url,slot) of (meal.photos||{})" v-bind:key="slot">
                      <h4>{{ slot }}</h4>
                      <v-img
                        @click="showImage=true; showImageUrl=url"
                        :src="url"
                      />
                    </v-col>
                  </v-row>
                  <v-chip-group column>
                    <v-chip v-for="tag of ((meal.tags||[]))" v-bind:key="tag">{{ tag }}</v-chip>
                    <v-chip outlined v-for="tag of (Object.values(meal.food_tags||{}))" v-bind:key="tag">{{ tag }}</v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import api from "@/api";
import {dateFormatted, formatCurrency} from "@/store/utils";
import urlState from "@/router/urlState";
import {mapActions, mapGetters, mapState} from "vuex";
import {getNextOrderingDate} from "../store/utils";

export default {
  name: "Menu",
  mixins: [urlState],
  data() {
    return {
      date: getNextOrderingDate(),
      chooseWeek: null,
      menu: null,
      showImage: null,
      showImageUrl: null,
      filter: '',
      error: null,
      isLoading: null,
      dateMenu: null,
      hideChefChoice: false,
      showTextMenu: false,
      // null until someone ticks a box: then the v1 visible streams are used
      textStreams: null,
      textMenuCopied: false
    }
  },
  mounted() {
    this.syncToUrl({
      param: 'date', urlParam: 'date', initFromRoute: true,
      // parseCallback: (v) => Array.isArray(v) ? v : [v]
    });
    this.syncToUrl({
      param: 'filter', urlParam: 'stream', initFromRoute: true,
      // parseCallback: (v) => Array.isArray(v) ? v : [v]
    });
    this.syncToUrl({
      param: 'showTextMenu', urlParam: 'text', initFromRoute: true,
      parseCallback: (v) => v === 'true',
      transformCallback: (v) => v ? 'true' : null
    });
    this.fetchStreams();
    this.fetchMenu(this.date);
  },
  watch: {
    date(d) {
      return this.fetchMenu(d);
    }
  },
  methods: {
    ...mapActions(['fetchStreams']),
    formatCurrency,
    dateFormatted,
    textMenuDate(d) {
      return moment(d).format('ddd, MMM Do');
    },
    // same ordering as the customer text menu on app.fedfedfed.com/v1
    sortByTod(meals) {
      const todOrder = {breakfast: 1, lunch: 2, dinner: 3, extras: 4};
      return [...(meals || [])].sort((a, b) =>
        (todOrder[a.tod] || 5) - (todOrder[b.tod] || 5) || (a.name || '').localeCompare(b.name || ''));
    },
    // html keeps the headings when pasted into a doc or email; plain text is the fallback
    async copyTextMenu() {
      const el = this.$refs.textMenu;
      try {
        await navigator.clipboard.write([new window.ClipboardItem({
          'text/html': new Blob([el.innerHTML], {type: 'text/html'}),
          'text/plain': new Blob([el.innerText], {type: 'text/plain'}),
        })]);
      } catch (e) {
        // no clipboard api (eg. served over http) - copying a selection also keeps the formatting
        console.warn('clipboard api copy failed, copying a selection instead', e);
        if (!this.copyBySelection(el)) {
          this.error = `could not copy the menu: ${e.message || e}`;
          return;
        }
      }
      this.textMenuCopied = true;
      setTimeout(() => this.textMenuCopied = false, 2000);
    },
    copyBySelection(el) {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(el);
      selection.removeAllRanges();
      selection.addRange(range);
      const copied = document.execCommand('copy');
      selection.removeAllRanges();
      return copied;
    },
    isSunday(d) {
      return moment(d).day() === 0;
    },
    fetchMenu(d) {
      this.isLoading = true;
      return api.get(`v2/menu/${d}`)
        .then(({data}) => {
          this.error = '';
          if (!data) {
            this.error = 'no menu found for this date';
          }
          this.menu = data;
        })
        .finally(() => this.isLoading = false);
    },
    generateMenu() {
      const confirmed = window.confirm(
        'This will publish a new menu for this week. ' +
        'Only do this if there were changes to the meals. Continue?'
      );
      if (!confirmed) {
        return;
      }
      this.isLoading = true;
      return api
        .post(`v2/menu/${this.date}`)
        .then(({data}) => {
          this.error = '';
          if (!data) {
            this.error = 'no menu found for this date';
          }
          this.menu = data;
        })
        .finally(() => this.isLoading = false);
    }
  },
  computed: {
    ...mapState(['streams']),
    ...mapGetters(['getStreamName']),
    displayMenu() {
      if (!this.menu) {
        return {};
      }
      const streams = {};
      let chefChoice = null;
      for (const [stream, value] of Object.entries(this.menu)) {
        const list = (value && value.menu) || [];
        if (!chefChoice) {
          const anyMeals = list.filter(({date}) => date === 'any');
          if (anyMeals.length) {
            chefChoice = {...value, menu: anyMeals};
          }
        }
        streams[stream] = {...value, menu: list.filter(({date}) => date !== 'any')};
      }
      const result = {...streams};
      if (chefChoice && !this.hideChefChoice) {
        result['Chef Choice'] = chefChoice;
      }
      return result;
    },
    // the streams app.fedfedfed.com/v1/menu shows (it never shows chef choice)
    v1MenuStreams() {
      return Object.keys(this.displayMenu).filter(id => this.streams[id] && this.streams[id].visible);
    },
    selectedTextStreams: {
      get() {
        return this.textStreams || this.v1MenuStreams;
      },
      set(streams) {
        this.textStreams = streams;
      }
    },
    textMenu() {
      return Object.fromEntries(Object.entries(this.displayMenu)
        .filter(([stream]) => this.selectedTextStreams.includes(stream)));
    },
    activeMenu() {
      if (this.filter) {
        const val = this.displayMenu[this.filter];
        const result = {};
        result[this.filter] = val;
        return result;
      } else {
        return this.displayMenu;
      }
    }
  }
}
</script>

<style scoped>

</style>